import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'polaKerjaPegawai'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const employeeList = 'Master/polaKerjaPegawai/listEmployee/'
export const employeeListcreate = 'Master/polaKerjaPegawai/listEmployee_create/'
export const polaKerjaList = 'Master/polaKerjaPegawai/listWorkingPattern/'

export const polaKerjaPegawaiCreate = 'Master/polaKerjaPegawai/create/'
export const polaKerjaPegawaiList = 'Master/polaKerjaPegawai/list/'
export const polaKerjaPegawaiDetail = 'Master/polaKerjaPegawai/detail/'
export const polaKerjaPegawaiUpdate = 'Master/polaKerjaPegawai/update/'
export const polaKerjaPegawaiInactive = 'Master/polaKerjaPegawai/inactive/'
export const polaKerjaPegawaiActive = 'Master/polaKerjaPegawai/active/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}